import { format } from 'url';

import { getPagePath } from '@spotahome/bff/client';

import { getSearchPageTitle } from '@common/utils/page-title-builder';
import pageMetadataBuilder from '@common/utils/page-metadata-builder';

import AdUrlService from '../../../LEGACY/javascripts/cornucopia/ads/ad-url-service';

function getfullUrl(req, pathname) {
  return format({
    protocol: process.env.NODE_ENV === 'production' ? 'https' : 'http',
    host: req.get('host'),
    pathname
  });
}

const getPageLink = (city, filters, page, req) => {
  const query = AdUrlService.createTranslatedQueryString({
    ...filters,
    page
  });

  const pathParams = {
    params: { city },
    locale: req.locale
  };

  let url = getPagePath(req.currentRoute, pathParams);

  url = getfullUrl(req, url);
  url += query.params ? `/${query.params}` : '';

  return url;
};

const getPaginationLinks = (paginator, city, filters, req) => {
  const nextPage = paginator.nextPageNumber;
  const prevPage = paginator.prevPageNumber;

  const links = [];

  if (prevPage) {
    links.push({
      rel: 'prev',
      href: getPageLink(city, filters, prevPage, req)
    });
  }

  if (nextPage) {
    links.push({
      rel: 'next',
      href: getPageLink(city, filters, nextPage, req)
    });
  }

  return links;
};

export const buildHeadersData = (
  city,
  clientConfig,
  metadata,
  filters,
  paginator,
  req
) => {
  const innerHTMLs = [`ga('set', 'dimension2', '${city}')`];
  let title = '';
  let metas = [];

  title = getSearchPageTitle(metadata, paginator.pageNumber);
  metas = pageMetadataBuilder({
    ...metadata,
    fb: {
      appId: clientConfig.FB_APP_ID
    },
    ms: {
      validate: clientConfig.MSVALIDATE
    }
  });

  return {
    title,
    metas,
    scripts: innerHTMLs.map(html => ({
      innerHTML: html
    })),
    links: getPaginationLinks(paginator, city, filters, req)
  };
};

export default {
  buildHeadersData
};
